export const APP_CONFIG = {
  appName: 'OG Canna',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080',
  authStorageKey: 'ogc-auth-token',
};

export const NAV_LINKS = [
  { to: '/productos', label: 'Productos' },
  { to: '/perfil', label: 'Mi Perfil' },
];